import dayjs from 'dayjs';
import parser from 'dayjs/plugin/customParseFormat';
import formatter from 'dayjs/plugin/localizedFormat';
import relative from 'dayjs/plugin/relativeTime';

import 'dayjs/locale/pt-br';

import { DATE_FORMAT_CHARS } from '@validators/date';

dayjs.extend(parser);
dayjs.extend(formatter);
dayjs.extend(relative);
dayjs.locale('pt-br');

export default function momentize(value = '', options = {}) {
  let result;

  try {
    result = dayjs(value, options.format || DATE_FORMAT_CHARS);
  } catch (err) { /* */ }

  if (result && result.isValid()) {
    if (options.output) {
      return result.format(options.output || DATE_FORMAT_CHARS);
    }

    return result.fromNow();
  }

  return undefined;
}
